export default __webpack_public_path__ + "img/6fa01e55c2bb28ef7e973f9204048a65.png";